import { cn } from "~/lib/utils";

export function AnwbLogo({ className }: { className?: string }) {
  return (
    <img
      src="/brands/anwb-logo.png"
      alt="ANWB"
      className={cn("object-contain object-left", className)}
    />
  );
}
